export default __webpack_public_path__ + "static/media/achievements_description.90188ccc.png";